<template>
	<div class="category">
		<el-row :gutter="10">
			<el-col :span="2">
				<el-input v-model="query.id" placeholder="请输入用户id"></el-input>
			</el-col>
			<el-col :span="1">
				<el-button class="pull-right" type="primary" @click="handleSearch">搜索</el-button>
			</el-col>
		</el-row>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column prop="user_id" label="用户ID"></el-table-column>
				<el-table-column prop="content" label="合并用户ID"></el-table-column>
				<el-table-column prop="qq" label="QQ"></el-table-column>
				<el-table-column prop="state" label="状态">
					<template slot-scope="{ row }">
						<el-button type="info" v-if="row.state == 0" @click="val =>changeConfig(row,1)">未合并</el-button>
						<el-button type="success" v-else @click="val =>changeConfig(row,0)">合并</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				background
				:total="dataMeta ? dataMeta.total : 0"
				:current-page="dataMeta ? dataMeta.current_page : 1"
				:page-size="dataMeta ? dataMeta.per_page : 15"
				@current-change="handlePageChange"
			></el-pagination>
		</div>
	</div>
</template>

<script>
import { mapActions } from 'vuex'
import { delApiData, getApiData, patchApiData } from '../../http'
import classification from '../../assets/js/classification'
export default {
	data() {
		return {
			classifications: classification,
			dataList: undefined,
			dataMeta: {},
			query: {
				page: 1,
				id: undefined
			},
			editInfo: undefined,
			loading: false,
			visible: false,
			buttonLoading: false,
			isEdit: false
		}
	},
	methods: {
		...mapActions(['getCaseList', 'getCategories', 'getBoxGroupList']),
		changeConfig(row, state) {
			let str = ''
			if (state === 1) {
				str = '合并'
			} else {
				str = '未合并'
			}
			this.$confirm('此操作将' + str + '当前数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				patchApiData('level_merge_status/' + row.id, {
					state: state
				})
					.then(
						res => {
							if (res.err) {
								this.$message.error(res.err)
							} else {
								this.$message.success('修改设置成功')
							}
							this.getData()
						}
					)
					.finally(() => {
						// this.loading = false
					})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				})
			})
		},
		getData() {
			this.loading = true
			getApiData(`level_merge_list`, { page: this.query.page, id: this.query.id })
				.then(res => {
					this.dataList = res.data
					this.dataMeta = {
						current_page: res.current_page,
						per_page: res.per_page,
						total: res.total
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		handleSearch() {
			this.query.page = 1
			this.getData()
		},
		handlePageChange(page) {
			this.query.page = page
			this.getData()
		},
		handleDelete(id) {
			this.$confirm('确定要删除吗？', {
					type: 'warning'
				}).then(res => {
					delApiData(`shop/${id}`).then(res => {
						this.$message.success('删除成功')
						this.getData()
					})
			})
		}
	},
	created() {
		this.getData()
	}
}
</script>

<style lang="less">
.table-image {
	max-height: 100px;
	max-width: 100px;
}

.avatar-uploader {
	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 128px;
		height: 128px;
		line-height: 128px;
		text-align: center;
	}

	.el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.el-upload:hover {
		border-color: #409eff;
	}

	.avatar {
		width: 128px;
		height: 128px;
		display: block;
	}
}

/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
.el-drawer__body {
	overflow: auto;
	/* overflow-x: auto; */
}

/*2.隐藏滚动条，太丑了*/
.el-drawer__container ::-webkit-scrollbar {
	display: none;
}


.abow_dialog {
	display: flex;
	justify-content: center;
	align-items: Center;
	overflow: hidden;

	.el-dialog {
		margin: 0 auto !important;
		height: 90%;
		overflow: hidden;

		.el-dialog__body {
			position: absolute;
			left: 0;
			top: 54px;
			bottom: 0;
			right: 0;
			padding: 0;
			z-index: 1;
			overflow: hidden;
			overflow-y: auto;
		}
	}
}
</style>
